import Request from 'files/Request.js';
import User from 'classes/User.js';

class ClientClass {

    access_token = null;
    active = null;
    address = null;
    avatar = null;
    id = null;
    location = null;
    name = null;
    payments_account = null;
    phone_number = null;
    preferences = null;
    primary_user = null;
    primary_user_id = null;
    public_auth_token = null;
    subscriptions = null;
    timezone = null;

    constructor() {
        return this;
    }

    apply = (utils, isNewTarget) => {
        return isNewTarget ? this.submit(utils) : this.update(utils);
    }

    close = async () => {
        return new Promise(resolve => {
            this.address = this.edits.address;
            this.location = this.edits.location;
            this.name = this.edits.name;
            this.phone_number = this.edits.phone_number;
            this.primary_user = this.edits.primary_user;
            this.timezone = this.edits.timezone;
            resolve();
        });
    }

    create = (props = {}) => {
        this.access_token = props.access_token;
        this.active = props.active;
        this.address = props.address;
        this.avatar = props.avatar;
        this.id = props.id;
        this.location = props.location && {
            latitude: props.location.lat,
            longitude: props.location.long
        };
        this.name = props.name;
        this.phone_number = props.phone_number;
        this.preferences = props.preferences || [];
        this.primary_user = props.primary_user && User.create(props.primary_user);
        this.primary_user_id = props.primary_user_id;
        this.public_auth_token = props.public_auth_token;
        this.timezone = props.timezone;
        return this;
    }
}

export const fetchClient = async (utils, id) => {
    return new Promise(async (resolve, reject) => {
        try {
            let { client } = await Request.get(utils, '/clients/', {
                type: 'details',
                id: id
            });
            resolve(new ClientClass().create(client));
        } catch(e){
            reject(e);
        }
    });
}

export default {
    create: props => new ClientClass().create(props),
    get: (utils, id) => fetchClient(utils, id),
    new: () => new ClientClass()
}
